import { useAnalyticsEvents } from '@atlaskit/analytics-next';

/**
 * Returns a callback that fires the standard "filter clicked" analytics event
 * for the given filter id.
 */
export const useFireFilterClickAnalytics = () => {
	const { createAnalyticsEvent } = useAnalyticsEvents();

	return (filterId: string) => {
		createAnalyticsEvent({
			origin: 'web',
			platform: 'web',
			product: 'marketing',
			source: 'none',
			userIdType: 'atlassianAccount',
			eventComponent: 'uniformFilterButton',
			event: 'clicked',
			eventType: 'ui',
			action: 'clicked',
			actionSubject: 'component',
			attributes: {
				labelEnglish: filterId,
				url: location.href,
				page_path: location.pathname,
				eventComponent: 'uniformFilterButton',
			},
		}).fire();
	};
};
